import * as React from 'react';

export const CompanySvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.596" height="29.375" viewBox="0 0 22.596 29.375"><g transform="translate(0 0)"><path d="M384.62,368v29.375h9.824v-7.091h2.947v7.091h9.824V368Zm6.877,25.323H388.55v-3.039H391.5Zm0-6.078H388.55v-3.039H391.5Zm0-6.078H388.55v-3.039H391.5Zm0-6.077H388.55v-3.039H391.5Zm5.895,12.155h-2.947v-3.039h2.947Zm0-6.078h-2.947v-3.039h2.947Zm0-6.077h-2.947v-3.039h2.947Zm5.895,18.233h-2.948v-3.039h2.948Zm0-6.078h-2.948v-3.039h2.948Zm0-6.078h-2.948v-3.039h2.948Zm0-6.077h-2.948v-3.039h2.948Z" transform="translate(-384.62 -368)" fill="#272343"/></g></svg>
  );
};
